import { DashboardModule, Form } from '@domain-group/suit-theme'

import { capitalizeString } from '@domain-group/javascript-utils'

import type { UseFormPayload } from '@domain-group/react-hooks'

import { mapEntityTypeToEntityKey } from '@functions/entity'

import EntitySelector from '@components/EntitySelector'

interface TrainingCourseDetailsProps {
  trainingCourseFormPayload: UseFormPayload,
}

const TrainingCourseDetails = (props: TrainingCourseDetailsProps) => {
  const { trainingCourseFormPayload } = props

  const {
    entityState: {
      audience_id,
      audience_type,
      title,
    },
    errors,
    handlers,
    setEntityState,
  } = trainingCourseFormPayload

  const entityKey = mapEntityTypeToEntityKey(audience_type)

  return (
    <DashboardModule title="Training Course Details">
      <Form padding="large">
        <Form.Field label="* Title" errorMessage={errors.title}>
          <input type="text" name="title" value={title} {...handlers} />
        </Form.Field>

        <Form.Row marginTop="large">
          <Form.Field label="* Audience" errorMessage={errors.audience_type}>
            <select
              name="audience_type"
              onChange={e => setEntityState({ audience_type: e.target.value, audience_id: null })}
              value={audience_type}
            >
              <option value="">Please Select...</option>
              <option value="Agency">Agencies</option>
              <option value="Brand">Brands</option>
              <option value="Provider">Providers</option>
              <option value="System">System</option>
            </select>
          </Form.Field>

          {!!audience_type && audience_type !== 'System' && (
            <EntitySelector
              callbacks={{
                // @ts-expect-error TS2322
                selectItem: (entity: { id?: number }) => setEntityState(
                  { audience_id: entity ? entity.id : null },
                ),
              }}
              entityKey={entityKey}
              errorMessage={errors.audience_id}
              // @ts-expect-error TS2322
              marginTop={['large', 0]}
              searchForwardProps={{ placeholder: `All ${capitalizeString(entityKey)}` }}
              selectedItemId={audience_id}
            />
          )}
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default TrainingCourseDetails
